const CourseStatus = {
  preEnroll: 'preenroll',
  draft: 'draft',
  launched: 'launched',
  inactive: 'inactive',
};

export default CourseStatus;
